import _ from 'lodash'

export default {
  SET_STATE: (state, payload) => {
    _.set(state, payload.action, payload.data)
  },
  
  SET_LAB_PRODUCTS: (state, payload) => {
    payload.data.forEach(element => {
      if (!element.quantity) {
        element.quantity = 0
      }
    })

    state.labProducts = payload.data
  },

  UPDATE_LAB_PRODUCTS: (state, payload) => {
    const index = _.findIndex(state.labProducts, { [payload.key]: payload.value })
    state.labProducts[index][payload.field] = payload.data
  },

  CLEAR_LAB_PRODUCTS: (state) => {
    state.labProducts = []
  }
}
